export default [ // 订单硬件发货
  {
    path: '/orderDevice/apply/online', // 江西上饶 硬件申请
    name: 'APPLYONLINE',
    component: () => import('@/views/orderDevice/applyOnline'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/orderDevice/apply/offline', // 线下申请
    name: 'APPLYOFFLINE',
    component: () => import('@/views/orderDevice/applyOffline')
  },
  {
    path: '/orderDevice/apply/result', // 线下申请-结果页
    name: 'APPLYOFFLINERESULT',
    component: () => import('@/views/orderDevice/applyOfflineResult')
  },
  {
    path: '/orderDevice/apply', // 领取方式中间页：线下-线上
    name: 'APPLYMIDDLE',
    component: () => import('@/views/orderDevice/applyMiddle')
  },
  {
    path: '/orderDevice/login',
    name: 'APPLYLOGIN',
    component: () => import('@/views/orderDevice/applyLogin'),
    meta: {
      title: '登录',
      loginNo: true
    }
  },
  {
    path: '/orderDevice/list',
    name: 'DEVICEORDERLIST',
    component: () => import('@/views/orderDevice/orderList'),
    meta: {
      title: '订单',
      keepAlive: true
    }
  },
  {
    path: '/orderDevice/confirm', // 提交信息
    name: 'DEVICEORDERCONFIRM',
    component: () => import('@/views/orderDevice/orderConfirm'),
    meta: {
      title: '订单'
    }
  },
  {
    path: '/orderDevice/detail',
    name: 'DEVICEORDERDETAIL',
    component: () => import('@/views/orderDevice/orderDetail'),
    meta: {
      title: '订单'
    }
  },
  {
    path: '/orderDevice/logisticsInfo',
    name: 'DEVICEORDERLOGISTICS',
    component: () => import('@/views/orderDevice/orderLogistics'),
    meta: {
      title: '物流'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/orderDevice.js